<style scoped>
@import "./index.css";
</style>

<template>
    <div>
        <Form ref="accountLogin" :model="accountLogin" :rules="accountLoginRule" :label-width="80">
            <FormItem prop="password" label="新密码">
                <Input clearable placeholder="请输入新的6-16位数字/字母或组合密码" icon="ios-unlock" size="large" type="password" v-model="accountLogin.password"></Input>
            </FormItem>
            <FormItem prop="repassword" label="确认密码">
                <Input clearable placeholder="请再次确认密码" icon="ios-unlock" size="large" type="password" v-model="accountLogin.repassword"></Input>
            </FormItem>
            <FormItem prop="verify_code" label="验证码" class="yzm">
                <Input clearable placeholder="请输入验证码" :maxlength="4" size="large" type="text" v-model="accountLogin.verify_code"></Input>
                <span :class="['yzm-btn',accountLogin.is_code === false ? 'active' : '']" @click="getCode">{{accountLogin.code_name}}</span>
            </FormItem>
            <FormItem class="mb5">
                <Button long size="large" :loading="accountLogin.btnLoading" type="primary" @click="handleSubmit('accountLogin')">
                    <span>{{!accountLogin.btnLoading ? '确定' : '修改中...'}}</span>
                </Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dsq:'',
            // +---------------
            // | 输入框数据
            // +---------------
            accountLogin: {
                password: "",
                repassword: "",
                verify_code:'',
                btnLoading: false,

                //验证码
                is_code:true,
                code_name:"获取验证码",
            },

            // +---------------
            // | 验证规则
            // +---------------
            accountLoginRule: {
                password: [
                    {
                        required:true,
                        trigger: "blur",
                        validator:this.validatePass
                    }
                ],
                repassword: [
                    {
                        required:true,
                        trigger: "blur",
                        validator:this.validatePassCheck
                    }
                ],
                verify_code: [
                    {pattern: /^\d{4}$/, required: true, message: "请输入4位数字验证码", trigger: "blur"},
                ],
            }
        }
    },
    created() {

    },
    computed:{
        userInfo(){
            return this.$store.state.user.userInfo
        }
    },
    methods: {
        validatePass(rule, value, callback)
        {
            if (value === '') {
                callback(new Error('请输入您的密码'));
            } else {
                if(this.$func.checkPassword(value)){
                    if (this.accountLogin.repassword !== '') {
                        // 对第二个密码框单独验证
                        this.$refs.accountLogin.validateField('repassword');
                    }
                }else{
                   callback(new Error('请输入新的6-16位数字/字母或组合密码'));
                }
                callback();
            }
        },
        validatePassCheck(rule, value, callback)
        {
            if (value === '') {
                callback(new Error('请再次输入您的密码'));
            } else {
                if(this.$func.checkPassword(value)){
                    if (value !== this.accountLogin.password) {
                        callback(new Error('2次密码不一致'));
                    }
                }else{
                    callback(new Error('请输入新的6-16位数字/字母或组合密码'));
                }
                callback();
            }
        },
        //验证密码
        validatePassword(rule, value, callback){
            const that = this;
            if (value === '') {
                callback(new Error(rule.message));
            } else {
                if (!that.$func.checkphone(that.accountLogin.phone)) {
                    callback(new Error(rule.message));
                }else{
                    that.accountLogin.is_code = true;
                }
                callback();
            }
        },
        //获取验证码
        getCode:function()
        {
            const that = this;
            //判断
            if(that.accountLogin.is_code)
            {
                if(that.$func.checkphone(that.userInfo.custPhone))
                {
                    //请求接口
                    that.$func.ajax('sendUpdatePwdCode',
                    {
                        phone: that.userInfo.custPhone
                    },
                    function(r) {
                        if(!r.statusCode){
                            that.$func.msg(r.message,'error');
                        }else{
                            that.accountLogin.is_code = false;
                            let _time  = 60;
                            //倒计时 并且 不可点击
                            that.dsq = setInterval(function(){
                                _time--;
                                if(_time > 0){
                                    that.accountLogin.code_name = _time+"秒";
                                }else if(_time == 0){
                                    clearInterval(that.dsq);
                                    that.accountLogin.is_code = true;
                                    that.accountLogin.code_name = "重新获取验证码";
                                }
                            },1000)
                        }
                    })
                }else{
                    that.$func.msg('请输入正确的手机号!')
                }
            }
        },
        // +---------------
        // | 提交表单
        // +---------------
        handleSubmit(name) {
            const that = this;
            //验证表单
            that.$refs[name].validate(valid => {
                if (valid)
                {
                    that.$func.ajax('updatePwd',
                    {
                        token    : that.$func.getToken(),
                        phone    : that.userInfo.custPhone,
                        phoneCode: that.accountLogin.verify_code,
                        newPwd   : that.accountLogin.repassword,
                        step     : 2
                    },function(r){
                        if(!r.statusCode){
                            that.$func.msg(r.message,'error');
                        }else{
                            //按钮状态关闭
                            that[name].btnLoading = false;
                            that[name].is_code    = true;
                            that[name].code_name  = '获取验证码';
                            clearInterval(that.dsq);
                            that.$refs[name].resetFields();
                            that.$func.msg('修改成功！');
                        }
                    })
                }
            });
        }
    }
};
</script>
